"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keycode = _interopRequireDefault(require("keycode"));

var _legend = _interopRequireDefault(require("@amzn/meridian-tokens/component/legend"));

var _victory = require("victory");

var _clamp = _interopRequireDefault(require("lodash/clamp"));

var _theme = require("../../theme");

var _victoryTooltip = _interopRequireDefault(require("../../_victory-tooltip"));

var _portal = _interopRequireDefault(require("../../portal"));

var _column = _interopRequireDefault(require("../../column"));

var _legend2 = _interopRequireWildcard(require("../../legend"));

var _popoverBody = _interopRequireDefault(require("../../_popover-body"));

var _legendContext = _interopRequireDefault(require("../../legend/_legend-context"));

var _useCallbackRef = _interopRequireDefault(require("../../use-callback-ref"));

var _clampIndex = _interopRequireDefault(require("./../../_utils/clamp-index"));

var _addDebouncedEventListener = _interopRequireDefault(require("./../../_utils/add-debounced-event-listener"));

var _visuallyHidden = _interopRequireDefault(require("./../../_styles/visually-hidden"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// HACK: We use position fixed here to fully hide the tooltip which will open in
// a React Portal.
var hiddenTooltipStyles = _objectSpread(_objectSpread({}, _visuallyHidden["default"]), {}, {
  position: "fixed",
  pointerEvents: "none"
});
/**
 * Options for the victory tooltip plugin.
 *
 * @name victoryTooltipPluginOptions
 * @typedef victoryTooltipPluginOptions
 * @type {object}
 * @property {string} [xAxisLabel] - The label for the chart's x axis (the
 *   independent axis). This will be used to add context to the data shown in
 *   a tooltip when the user hovers over the chart.
 * @property {boolean} [showCrosshair] - Set this to true to show a crosshair
 *   through the active data points when a tooltip is shown on hover.
 * @property {React.RefObject<*>} [containerRef] - A React ref object attached
 *   to the chart's container (via the `containerRef` prop on the Victory
 *   container component). This is only necessary if you need the ref for other
 *   purposes, otherwise the plugin will create an internal ref and use that.
 */

/* eslint-disable react/display-name */

/**
 * Add keyboard-friendly tooltips to a Victory Chart when combined with the
 * Meridian Legend.
 *
 * See the [Bar](https://meridian.a2z.com/data-visualization/bar/?platform=react-web),
 * [Line](https://meridian.a2z.com/data-visualization/line/?platform=react-web),
 * or [Scatter](https://meridian.a2z.com/data-visualization/scatter/?platform=react-web),
 * data visualization documentation for details on usage.
 *
 * @param {victoryTooltipPluginOptions} [options] - Configuration for the
 *   plugin.
 *
 * @return {*} - The instantiated plugin to be passed to the `LegendProvider`
 *   component's `plugins` prop.
 */


var victoryTooltipPlugin = function victoryTooltipPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (legend) {
    var _useState = (0, _react.useState)(),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        valueFocusIndex = _useState2[0],
        setValueFocus = _useState2[1];

    var defaultContainerRef = (0, _react.useRef)();
    var containerRef = options.containerRef || defaultContainerRef; // Victory uses old-school callback refs

    var containerCallbackRef = (0, _useCallbackRef["default"])(containerRef); // Return the focus state of a particular value in a dataset

    var getValueFocus = (0, _react.useCallback)(function (index, valueCount) {
      return parseInt(index) === (0, _clampIndex["default"])(valueFocusIndex, valueCount);
    }, [valueFocusIndex]); // Focus the first data point along a dataset when the legend is focused

    var onFocus = (0, _react.useCallback)(function () {
      legend.onFocus();

      if (legend.focusIndex === undefined) {
        setValueFocus(0);
      }
    }, [legend]); // Clear the focused data point when the legend is blurred

    var onBlur = (0, _react.useCallback)(function () {
      legend.onBlur();
      setValueFocus();
    }, [legend]); // Override the left/right arrow key behavior to move between data points
    // within a single dataset/legend item as opposed to between different
    // datasets/legend items.

    var onKeyDown = (0, _react.useCallback)(function (event) {
      var key = (0, _keycode["default"])(event);

      if (key === "right") {
        setValueFocus(valueFocusIndex + 1);
        event.preventDefault();
      } else if (key === "left") {
        setValueFocus(valueFocusIndex - 1);
        event.preventDefault();
      } else {
        legend.onKeyDown(event);
      }
    }, [legend, valueFocusIndex]); // The VoronoiContainerTooltip component uses this to optimize its render time.

    var cachedTooltipBounds = (0, _react.useRef)();
    return {
      _context: {
        containerRef: containerRef,
        cachedTooltipBounds: cachedTooltipBounds,
        getValueFocus: getValueFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown
      },
      // Render an element that can be used to announce tooltip content for screen
      // readers
      _elements: /*#__PURE__*/_react["default"].createElement(_portal["default"], {
        key: "victory-tooltip-announce"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(legend.id, "-tooltip-announce"),
        "aria-live": "polite",
        style: hiddenTooltipStyles
      })),
      api: {
        voronoiContainerProps: {
          containerRef: containerCallbackRef,
          voronoiDimension: "x",
          disable: valueFocusIndex !== undefined,
          labelComponent: /*#__PURE__*/_react["default"].createElement(VoronoiContainerTooltip, {
            xAxisLabel: options.xAxisLabel,
            showCrosshair: options.showCrosshair
          })
        },
        Tooltip: Tooltip
      }
    };
  };
};
/* eslint-enable react/display-name */

/**
 * This tooltip renders information for a single data point from a single
 * dataset. This is designed to be used with components like VictoryLine or
 * VictoryBar
 */


var Tooltip = function Tooltip(props) {
  var legend = (0, _react.useContext)(_legendContext["default"]);
  var index = props.data.reduce(function (result, datum, index) {
    return datum._x === props.datum._x ? index : result;
  }, -1);
  var active = legend.getFocus(props.legendKey) && legend.getValueFocus(index, props.data.length); // Announce the tooltip content for screen readers

  (0, _react.useEffect)(function () {
    if (active) {
      var announce = document.getElementById("".concat(legend.id, "-tooltip-announce"));
      var text = props.ariaLabels ? props.ariaLabels(props) : props.text(props);

      if (announce.innerText !== text) {
        announce.innerText = text;
      }
    }
  }, [legend, props, active]);
  return /*#__PURE__*/_react["default"].createElement(_victoryTooltip["default"], (0, _extends2["default"])({}, props, {
    active: active
  }));
};

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The key of the legend item this tooltip is associated with.
   */
  legendKey: _propTypes["default"].string.isRequired,

  /**
   * Generate separate labels for screen readers to provide context that would
   * otherwise only be apparent visually.
   */
  ariaLabels: _propTypes["default"].func,

  /**
   * The chart data (provided by Victory).
   */
  data: _propTypes["default"].array,

  /**
   * The data point that the tooltip labels (provided by Victory).
   */
  datum: _propTypes["default"].object,

  /**
   * A function that will return the tooltip text when passed all the tooltip
   * props (provided by Victory).
   */
  text: _propTypes["default"].func
} : {}; // Assign display name to "VictoryTooltip" to keep these prop types from appearing
// in the meridian.a2z.com/components/tooltip API tab

Tooltip.displayName = "VictoryTooltip";
/**
 * This tooltip renders information for multiple data points from different
 * datasets. This is designed to be used with the VictoryVoronoiContainer
 * component.
 */

var VoronoiContainerTooltip = function VoronoiContainerTooltip(props) {
  var t = (0, _theme.useTheme)(_legend["default"], "legend");
  var legend = (0, _react.useContext)(_legendContext["default"]);
  var tooltipElement = (0, _react.useRef)(); // Force re-render in scroll and resize useEffect

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      updateState = _useState4[1]; // The tooltip position is calculated by converting the SVG coordinates passed
  // in via props.x and props.y (generated by Victory) to browser viewport
  // coordinates (using the bounding client rectangle of the chart's container).
  // We use the x/y props and the containerRef here instead of rendering an
  // empty svg element at the x/y props and then extracting the viewport
  // position of that element to avoid the lost frame in the render -> measure
  // -> render cycle. Rendering ASAP is important to keep the tooltip from
  // flickering as the user scrubs through the data in a chart.


  var containerBounds = legend.containerRef.current.getBoundingClientRect();
  var containerScale = containerBounds.width / props.width; // Get the tooltip bounds. Cache these up at the legend level to minimize the
  // likelihood of the tooltip jumping around between the first render (when the
  // tooltipElement ref is empty) and the second render (when the tooltipElement
  // ref is initialized and we can measure the tooltip). Caching via the legend
  // is necessary because Victory treats the tooltip for each separate datapoint
  // as a different element, so this component gets unmounted/remounted
  // constantly as the user mouses around the chart.

  var tooltipBounds = tooltipElement.current ? tooltipElement.current.getBoundingClientRect() : legend.cachedTooltipBounds.current;
  legend.cachedTooltipBounds.current = tooltipBounds; // Get the SVG coordinates of the minimum and maximum y values included in the
  // chart's domain.

  var chartRangeVertical = props.orientation === "top" || props.orientation === "bottom" ? props.scale.y.range() : props.scale.x.range(); // Calculate the actual viewport x/y position of the tooltip

  var rawViewportX = props.x * containerScale + containerBounds.left;
  var rawViewportY = chartRangeVertical[1] * containerScale + containerBounds.top; // Flip the tooltip below the visualization if there isn't enough space for it
  // above (the default position).

  var tooltipArrowHeight = t("tooltipArrowHeight");
  var flipBelow = tooltipBounds && tooltipBounds.height + tooltipArrowHeight > rawViewportY; // Calculate the viewport x position of the tooltip when constrained to show
  // within the horizontal bounds of the visualization.

  var viewportX = tooltipBounds ? (0, _clamp["default"])(rawViewportX, containerBounds.left + tooltipBounds.width / 2, containerBounds.left + containerBounds.width - tooltipBounds.width / 2) : rawViewportX;
  var viewportY = flipBelow ? chartRangeVertical[0] * containerScale + containerBounds.top : rawViewportY;
  var title = props.datum.xName || props.datum._x; // Collect all supplemental items for each active point

  var supplementalItems = [];

  if (props.activePoints) {
    supplementalItems = supplementalItems = props.activePoints.reduce(function (supplementalItems, point) {
      return [].concat((0, _toConsumableArray2["default"])(supplementalItems), (0, _toConsumableArray2["default"])(point.supplementalItems || []));
    }, []);
  } // Force a re-render on whenever another element scrolls or the document resizes
  // to keep the popover stuck to the chart.


  (0, _react.useEffect)(function () {
    var forceRerender = function forceRerender() {
      return updateState({});
    };

    var removeScrollListener = (0, _addDebouncedEventListener["default"])(document, "scroll", forceRerender, true);
    var removeResizeListener = (0, _addDebouncedEventListener["default"])(document, "scroll", forceRerender, true);
    return function () {
      removeScrollListener();
      removeResizeListener();
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.showCrosshair ? /*#__PURE__*/_react["default"].createElement(_victory.LineSegment, {
    style: {
      stroke: t("tooltipCrosshairColor"),
      strokeWidth: t("tooltipCrosshairWidth")
    },
    x1: props.x,
    x2: props.x,
    y1: chartRangeVertical[1],
    y2: chartRangeVertical[0]
  }) : null, props.showCrosshair ? props.activePoints.map(function (point) {
    var item = legend.getItem(point.style.data.key);
    return item ? /*#__PURE__*/_react["default"].createElement(_victory.Point, {
      key: point.childName,
      x: props.scale.x(point._x),
      y: props.scale.y(point._y),
      symbol: item.symbol,
      style: {
        fill: item.color
      },
      size: 7
    }) : null;
  }) : null, /*#__PURE__*/_react["default"].createElement(_portal["default"], null, /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], {
    style: {
      top: viewportY + (flipBelow ? 1 : -1) * tooltipArrowHeight,
      left: viewportX,
      position: "fixed",
      transform: "translateX(-50%) translateY(".concat(flipBelow ? "0" : "-100%", ")"),
      pointerEvents: "none"
    },
    spacingInset: "none",
    arrowPosition: flipBelow ? "top" : "bottom",
    arrowOffset: rawViewportX - viewportX,
    ref: tooltipElement
  }, /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacing: "small",
    spacingInset: "400"
  }, title !== undefined ? /*#__PURE__*/_react["default"].createElement("strong", null, [props.xAxisLabel, title].filter(function (str) {
    return str !== undefined;
  }).join(" - ")) : null, supplementalItems.length ? /*#__PURE__*/_react["default"].createElement(_legend2.LegendProvider, {
    data: legend.data,
    supplementalItems: supplementalItems,
    colorScale: legend.colorScale,
    "aria-label": legend["aria-label"],
    "aria-labelledby": legend["aria-labelledby"]
  }, /*#__PURE__*/_react["default"].createElement(_legend2["default"], {
    values: function values(item) {
      var activePointIndex = props.activePoints.findIndex(function (point) {
        return point.style.data.key === item.key;
      }); // If the active points index >= 0 (coming from `data` rather
      // than `supplementalItems`), return its formatted value

      if (activePointIndex >= 0) {
        var _props$activePoints$a = props.activePoints[activePointIndex].showInLegend,
            showInLegend = _props$activePoints$a === void 0 ? true : _props$activePoints$a; // Only return formatted value if the point is not hidden

        if (showInLegend) {
          return props.text[activePointIndex];
        }
      } // Else the item is from `supplementalItems` so return its raw value
      else if (item.value) {
        return item.value;
      }
    }
  })) : /*#__PURE__*/_react["default"].createElement(_legend2["default"], {
    values: function values(item) {
      var activePointIndex = props.activePoints.findIndex(function (point) {
        return point.style.data.key === item.key;
      });

      if (activePointIndex >= 0) {
        var _props$activePoints$a2 = props.activePoints[activePointIndex].showInLegend,
            showInLegend = _props$activePoints$a2 === void 0 ? true : _props$activePoints$a2; // Only return formatted value if the point is not hidden

        if (showInLegend) {
          return props.text[activePointIndex];
        }
      }
    }
  })))));
};

VoronoiContainerTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The array of points labelled by the tooltip (provided by Victory).
   */
  activePoints: _propTypes["default"].array,

  /**
   * Chart metadata like axis label and category name (provided by Victory).
   */
  datum: _propTypes["default"].object,

  /**
   * The orientation of the data in the chart (provided by Victory).
   */
  orientation: _propTypes["default"].string,

  /**
   * D3 scales for the x and y axis (provided by Victory).
   */
  scale: _propTypes["default"].object,

  /**
   * Set this to true to show a crosshair through the active data points when a
   * tooltip is shown on hover.
   */
  showCrosshair: _propTypes["default"].bool,

  /**
   * An array of tooltip text for each active point (provided by Victory).
   */
  text: _propTypes["default"].array,

  /**
   * The native width of the chart image in pixels (provided by Victory).
   */
  width: _propTypes["default"].number,

  /**
   * The x position of the tooltip in SVG units (provided by Victory).
   */
  x: _propTypes["default"].number,

  /**
   * The label of the x axis.
   */
  xAxisLabel: _propTypes["default"].string
} : {};
var _default = victoryTooltipPlugin;
exports["default"] = _default;